import { render, staticRenderFns } from "./ChatConversasPage.vue?vue&type=template&id=3e00e502&scoped=true"
import script from "./ChatConversasPage.vue?vue&type=script&lang=js"
export * from "./ChatConversasPage.vue?vue&type=script&lang=js"
import style0 from "./ChatConversasPage.vue?vue&type=style&index=0&id=3e00e502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e00e502",
  null
  
)

export default component.exports